import { loadStripe, Stripe } from '@stripe/stripe-js';

const STRIPE_PUBLISHABLE_KEY =
  process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY || '';

const stripePromiseCache = new Map<string, Promise<Stripe | null>>();

export function getStripe(stripeAccount: string) {
  const stripePromiseData = stripePromiseCache.get(stripeAccount);
  if (stripePromiseData) {
    return stripePromiseData;
  }

  const stripePromise = loadStripe(STRIPE_PUBLISHABLE_KEY, { stripeAccount });
  stripePromiseCache.set(stripeAccount, stripePromise);

  return stripePromise;
}
